import Gap from '~/components/Gap';
import Text from '~/components/Text';
import { IListEstimate } from '~/types/estimate';
import { getEstimateStatus } from './helpers';
import { useIsDesktop } from '~/hooks/useIsDesktop';

interface IEstimateDueStatusProps {
  estimateData: IListEstimate;
}

const EstimateDueStatus = ({ estimateData }: IEstimateDueStatusProps) => {
  const isDesktop = useIsDesktop();

  if (estimateData.archived === true) {
    return null;
  }
  const dueStatus = getEstimateStatus(estimateData);
  return (
    <div className="align-center">
      {dueStatus.icon && (
        <>
          <dueStatus.icon size={isDesktop ? 12 : 8} color={`var(--${dueStatus.color})`} />
          <Gap r={3} />
        </>
      )}
      <Text size={isDesktop ? 'xs' : 'xxs'} variant={dueStatus.color}>
        {dueStatus.label}
      </Text>
    </div>
  );
};

export default EstimateDueStatus;
